import { render, staticRenderFns } from "./ReturnNotesList.vue?vue&type=template&id=534e65b7&scoped=true"
import script from "./ReturnNotesList.vue?vue&type=script&lang=js"
export * from "./ReturnNotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e65b7",
  null
  
)

export default component.exports